/* globals window */

import logger from '../logger';

/**
 * EventTracker
 * @return {Object}
 */
const eventTracker = () => {
  const dataLayer = window.dataLayer || [];

  /**
   * Push the event object into the dataLayer array
   * @param {Object} data
   */
  function dataLayerPush(data) {
    if (!window.google_tag_manager) {
      return Promise.resolve();
    }

    return new Promise((resolve) => {
      data.eventCallback = resolve;
      data.eventTimeout = 2000;

      dataLayer.push(data);
      logger.notice(`push ${data.event} to dataLayer - ${JSON.stringify(data, null, 2)}`);
    });
  }

  return {
    dataLayerPush,
  };
};

export default eventTracker();



// WEBPACK FOOTER //
// ./resources/assets/js/components/eventTracker/eventTracker.js